import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';

import { FavoritesFolders } from '../../components/FavoritesFolders';
import { useOfferCardContext } from '../../context';

export function FavoritesFoldersContainer() {
  const { user } = useOfferCardContext();

  const handleLogin = () => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  };

  return (
    <FavoritesFolders>
      <FavoritesAssignWidgetContainer
        isAuthenticated={user.isAuthenticated}
        disableNotification={true}
        onWaitForLogin={handleLogin}
      />
    </FavoritesFolders>
  );
}
